module.exports = __webpack_public_path__ + "img/altitude-room-2.495588b4.jpg";